import React, { useEffect, useState } from "react";

import { useForm } from "../useForm";

import WipFields from "./WipFields";
import IncomingWipItemsTableComponent from "./IncomingWipItemsTableComponent";
import { wipStatusOptions, isReadOnlyUser } from "../../../shared/utility";
import OutgoingWipItemsTableComponent from "./OutgoingWipItemsTableComponent";
import ButtonDropdown from "../../controls/ButtonDropdown";

const initialFValues = {
  id: 0,
  room_selected: { value: -1 },
  lot_number: "",
  scanned_barcode: null,
  status_selected: { value: -1 },
};

export default function CreateWipForm(props) {
  const {
    createWip,
    isEdit,
    wip,
    roomOptions,
    onAddItemToWipByBarcode,
    updateWip,
    openSlideForManufacturedItemDetails,
    onAskReturnIncomingItem,
    onAskDeleteWipOutputItem,
    openAddPriceGroupModal,
    setOutgoingSelectedItems,
    outgoingSelectedItems,
    calculateCostForWipOutgoingItems,
    showErrorModal,
    printWipDetailsReport,
    printWipSummaryReport,
    printWipDerivativesReport,
    loadingRows,
    rowDetails,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    fetchRowDetails,
    onWipItemTotalCostEditComplete,
    setEmptyModelOpen,
  } = props;

  const {
    fetchOutgoingRowDetails,
    outgoingLoadingRows,
    outgoingRowDetails,
    fetchOutgoingSubRowDetails,
    outgoingSubRowDetails,
    outgoingSubLoadingRows,
    setOutgoingRowDetails,
    setOutgoingSubRowDetails,
  } = props.outgoing;

  const isReadOnly = isReadOnlyUser();

  const buttonOptions = [
    {
      name: "WIP Summary Report",
      onClick: printWipSummaryReport,
      inProgress: false,
    },
    {
      name: "WIP Details Report",
      onClick: printWipDetailsReport,
      inProgress: false,
    },
    {
      name: "WIP Derivatives Report",
      onClick: printWipDerivativesReport,
      inProgress: false,
    },
  ];

  const [submitInProgress, setSubmitInProgress] = useState(false);

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("room_selected" in fieldValues) {
      temp.room_selected = null;
      if (fieldValues.room_selected.value === -1) {
        temp.room_selected = "This field is required.";
      }
    }

    if ("lot_number" in fieldValues) {
      temp.lot_number = null;
      if (fieldValues.lot_number === "") {
        temp.lot_number = "This field is required.";
      }
    }

    if ("status_selected" in fieldValues) {
      temp.status_selected = null;
      if (fieldValues.status_selected.value === 1) {
        const totalCostPercentage = parseFloat(values.outgoing_info.total_cost_percentage);
        if (
          (totalCostPercentage < 99.0 || totalCostPercentage > 101.0) &&
          values.outgoing_items.length > 0
        ) {
          showErrorModal("Make sure total cost percentage is between 99.0 and 101.0");
          temp.status_selected = "Make sure total cost percentage is between 99.0 and 101.0";
        }
      }
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === null);
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate
  );

  useEffect(() => {
    if (wip) {
      var roomSelected = [];
      if (wip.room_id) {
        roomSelected = roomOptions.find((el) => el.value === wip.room_id);
      }

      var statusSelected = [];
      if (wip.status >= 0) {
        statusSelected = wipStatusOptions.find((el) => el.value === wip.status);
      }

      setValues({
        ...values,
        ...wip,
        room_selected: roomSelected,
        status_selected: statusSelected,
      });
    }
  }, [wip]);

  const handleSubmit = () => {
    if (validate()) {
      if (isEdit) {
        updateWip(values);
      } else {
        createWip(values);
      }
    }
  };

  return (
    <div className="justify-between">
      <div className="hide-for-print">
        <div className="flex items-center justify-between flex-wrap sm:flex-nowrap">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              {isEdit ? "Editing wip #" + values.id : "Create WIP"}
            </h3>
          </div>
          {!isReadOnly && (
            <div className="flex">
              {isEdit ? (
                <ButtonDropdown
                  items={buttonOptions}
                  mainOption="Save"
                  mainAction={handleSubmit}
                />
              ) : null}
            </div>
          )}
        </div>
        <WipFields
          setEmptyModelOpen={setEmptyModelOpen}
          handleInputChange={handleInputChange}
          values={values}
          errors={errors}
          handleSubmit={handleSubmit}
          submitInProgress={submitInProgress}
          roomOptions={roomOptions}
          onAddItemToWipByBarcode={onAddItemToWipByBarcode}
          isEdit={isEdit}
          printWipDetailsReport={printWipDetailsReport}
        />

        {values.id > 0 ? (
          <div>
            <IncomingWipItemsTableComponent
              loading={false}
              values={values}
              openSlideForManufacturedItemDetails={
                openSlideForManufacturedItemDetails
              }
              onAskReturnIncomingItem={onAskReturnIncomingItem}
              loadingRows={loadingRows}
              rowDetails={rowDetails}
              fetchSubRowDetails={fetchSubRowDetails}
              subRowDetails={subRowDetails}
              subLoadingRows={subLoadingRows}
              fetchRowDetails={fetchRowDetails}
              onWipItemTotalCostEditComplete={onWipItemTotalCostEditComplete}
            />
            <OutgoingWipItemsTableComponent
              loading={false}
              values={values}
              openSlideForManufacturedItemDetails={
                openSlideForManufacturedItemDetails
              }
              onAskDeleteWipOutputItem={onAskDeleteWipOutputItem}
              openAddPriceGroupModal={openAddPriceGroupModal}
              setOutgoingSelectedItems={setOutgoingSelectedItems}
              outgoingSelectedItems={outgoingSelectedItems}
              calculateCostForWipOutgoingItems={
                calculateCostForWipOutgoingItems
              }
              isEdit={isEdit}
              fetchOutgoingRowDetails={fetchOutgoingRowDetails}
              outgoingLoadingRows={outgoingLoadingRows}
              outgoingRowDetails={outgoingRowDetails}
              fetchOutgoingSubRowDetails={fetchOutgoingSubRowDetails}
              outgoingSubRowDetails={outgoingSubRowDetails}
              outgoingSubLoadingRows={outgoingSubLoadingRows}
              setOutgoingRowDetails={setOutgoingRowDetails}
              setOutgoingSubRowDetails={setOutgoingSubRowDetails}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
